export const BOOST_ALLOWED_ROLES = [
	'BrokerOwner',
	'LoanOfficer',
	'MarketingManager',
];
